import React, { useState, useEffect } from "react";
import { format, differenceInDays } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import queryString from "query-string";
import CSVReader from "react-csv-reader";
import { ToastContainer, toast } from "react-toastify";
import { CSVLink } from "react-csv";
import Amplify, { Auth, API } from "aws-amplify";
import moment from "moment";
import classNames from "classnames";
import Swal from "sweetalert2";
import { EmitterStatus } from "../../event";
import {
  PDFDownloadLink,
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { pad } from "../../utils/getLocalDateTime";
import ReactExport from "react-data-export";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// HOOKS
import useGetLoan from "../../hooks/useGetLoan";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import BuroTable from "./buroTable";
import PrevPage from "../Pagination/PrevPage";
import NumberPage from "../Pagination/NumberPage";
import NextPage from "../Pagination/NextPage";
import SelectRows from "../Pagination/SelectRows";
import DataEmpty from "../DataEmpty";

// Lotte
import Lottie from "react-lottie";
import Loading from "../../animation/loading.json";

// UTILS
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const optionsLimit = [
  {
    label: 15,
    value: 15,
  },
  { label: 30, value: 30 },
  { label: 45, value: 45 },
  { label: 60, value: 60 },
  { label: 75, value: 75 },
];

function Buro(props) {
  const Limit = 75;
  const dispatch = useDispatch();
  const router = useHistory();
  const search = router.location.search;

  const { user } = useSelector((state) => state.initializeApp);
  const searchBar = useSelector((state) => state.searchBar);

  const today = getCurrentLocalDateTime();
  const nextWeek = new Date();
  const preWeek = new Date();

  nextWeek.setDate(new Date().getDate());
  nextWeek.setFullYear(nextWeek.getFullYear());
  preWeek.setDate(new Date().getDate());
  const defaultMaxOverdueDate = getCurrentLocalDateTime(
    new Date(+today.year, today.monthIndex, +today.date)
  );
  const defaultMinOverdueDate = getCurrentLocalDateTime(
    new Date(+today.year, today.monthIndex, +today.date)
  );
  const defaultPayDate = today.fullDate;
  const defaultBeginOverdueDate = getCurrentLocalDateTime(preWeek);
  const defaultEndOverdueDate = getCurrentLocalDateTime(nextWeek);

  const querySearch = queryString.parse(search);

  const DEFAULT_QUERY = {
    Limit,
    countData: 1,
    paid_date: defaultPayDate,
    package: "All",
    status: "ACTIVE",
    min_created: "",
    max_created: defaultEndOverdueDate.fullDate,
    SELECT_ALL: true,
    // ProjectionExpression: ",buroDate",
    // overDueDate: today.fullDate,
  };

  const todayBuro = new Date();
  todayBuro.setMonth(todayBuro.getMonth() - 2);
  const isLeapyear = leapYear(todayBuro.getFullYear());
  const FABRUARY_DAYS = isLeapyear ? 29 : 28;

  const months = [
    { month: "January", days: 31, index: 0, monthTh: "มกราคม" },
    {
      month: "February",
      days: FABRUARY_DAYS,
      index: 1,
      monthTh: "กุมภาพันธ์",
    },
    { month: "March", days: 31, index: 2, monthTh: "มีนาคม" },
    { month: "April", days: 30, index: 3, monthTh: "เมษายน" },
    { month: "May", days: 31, index: 4, monthTh: "พฤษภาคม" },
    { month: "June", days: 30, index: 5, monthTh: "มิถุนายน" },
    { month: "July", days: 31, index: 6, monthTh: "กรกฎาคม" },
    { month: "August", days: 31, index: 7, monthTh: "สิงหาคม" },
    { month: "September", days: 30, index: 8, monthTh: "กันยายน" },
    { month: "October", days: 31, index: 9, monthTh: "ตุลาคม" },
    { month: "November", days: 30, index: 10, monthTh: "พฤศจิกายน" },
    { month: "December", days: 31, index: 11, monthTh: "ธันวาคม" },
  ];

  todayBuro.setDate(months[todayBuro.getMonth()].days);

  const { datas, loading, error, getData, count } = useGetLoan(DEFAULT_QUERY);

  const [loadingUpdateBuro, setLoadingUpdateBuro] = useState(false);
  const [searchBy, setSearchBy] = useState("loan_id");
  const [loadingImport, setLoadingImport] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState({ value: Limit, label: Limit });
  const [pageType, setPageType] = useState(null);
  const [overDueDate, setOverDueDate] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [currentDate, setCurrentDate] = useState(
    format(new Date(todayBuro), "yyyy-MM-dd")
  );
  const [dataExport, setDataExport] = useState([]);
  const [firstLanding, setFirstLanding] = useState(true);

  const [query, setQuery] = useState(DEFAULT_QUERY);
  useEffect(async () => {
    if (firstLanding) {
      return setFirstLanding(false);
    }

    const { value } = searchBar;
    const newQuery = {
      ...query,
      [searchBy]: value,
    };
    setQuery(newQuery);
    await getData(newQuery);
  }, [searchBar]);

  if (loading)
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  if (error) return <p className="text-black">Error</p>;

  const onField = (e) => {
    const { name, value } = e.target;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onClickResetFilter = async () => {
    setQuery(DEFAULT_QUERY);
    await getData(DEFAULT_QUERY);
    setFirstLanding(true);
    setSearchBy("loan_id");
    dispatch(onChangeSearchBar(""));
  };

  const getExclusiveStartKey = (index) => {
    if (query.status === "All") {
      return `isCreated=true&loan_id=${datas[index].loan_id}`;
    }
    return `loan_status=${datas[index].loan_status}&loan_id=${datas[index].loan_id}`;
  };

  const onChangeLimit = async (e) => {
    setPageSize(e);
    let newQuery = {
      ...query,
      Limit: e.value,
    };
    await getData(newQuery);
  };

  const onClickPrevPage = async () => {
    const newQuery = {
      ...query,
      Limit: +Limit,
      countData: 1,
      ScanIndexForward: true,
      ExclusiveStartKey: getExclusiveStartKey(0),
    };
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await getData(newQuery, { sortBy: true, isLoading: true });
  };

  const onClickNextPage = async () => {
    const lastIndex = datas.length - 1;
    const newQuery = {
      ...query,
      countData: 1,
      ScanIndexForward: false,
      Limit: +Limit,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await getData(newQuery);
  };

  const getNumberPage = (currentNumber) => {
    let newCurrent = currentNumber;
    const pageActive = pageIndex + 1;
    const conditionNext = pageActive >= sliceNumber;
    const conditionPrev = pageActive <= sliceNumber && pageActive > 1;
    const valueNext = totalPage - sliceNumber;
    const valuePrev = sliceNumber - pageActive - 1;
    switch (pageType) {
      case "NEXT":
        if (conditionNext) {
          newCurrent += valueNext;
        }
        return newCurrent;
      case "PREV":
        if (conditionPrev) {
          newCurrent -= valuePrev;
        }
        return newCurrent;
      case "NUMBER_PAGE":
        if (conditionNext) {
          newCurrent += valueNext;
        } else if (conditionPrev) {
          newCurrent -= valuePrev;
        }
        return newCurrent;
      default:
        return newCurrent;
    }
  };

  const onClickNumberPage = async (number) => {
    const countData = number - pageIndex;
    const scanIndexForward = countData > 0 ? false : true;
    const index = !scanIndexForward ? datas.length - 1 : 0;
    const newQuery = {
      ...query,
      Limit,
      countData: Math.abs(countData),
      ScanIndexForward: scanIndexForward,
      ExclusiveStartKey: getExclusiveStartKey(index),
    };
    setPageIndex(number);
    setPageType("NUMBER_PAGE");
    if (!scanIndexForward) {
      return await getData(newQuery);
    }
    return await getData(newQuery, { sortBy: true, isLoading: true });
  };

  const onSubmitFilter = async () => {
    await getData(query);
  };

  const onUpdateBuroDate = async () => {
    try {
      const result = await Swal.fire({
        title: `คุณยืนยันที่จะอัพเดตวันที่\n ${format(
          new Date(),
          "dd-MM-yyyy HH:mm"
        )} นี้หรือไม่ ?`,
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            await API.put("MoneyHubAdmin", "/creditBuro", {
              body: {
                adminName: user.username,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          } catch (error) {
            await EmitterStatus("ERROR", { logMessage: error });
          }
        },
      });
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await getData(query, { isLoading: false });
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingUpdateBuro(false);
    }
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const refresh = async () => {
    await getData(query);
  };

  const totalPage = Math.ceil(count / pageSize.value);
  const sliceNumber = 3;

  const paginationPages = new Array(totalPage)?.fill(0)?.slice(0, sliceNumber);
  const canNextPage = pageIndex + 1 !== totalPage;
  const canPreviousPage = pageIndex !== 0;

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  const onImportExcel = async (importDatas, fileInfo) => {
    try {
      setLoadingImport(true);
      for (const importData of importDatas) {
        await API.put("MoneyHubAdmin", `/creditBuro/ems`, {
          body: {
            fullname: importData.name,
            ems_initial: importData.ems_initial,
            ems_year: importData.ems_year,
            ems_initial_date: importData.ems_initial_date,
            ems_year_date: importData.ems_year_date,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
      await getData(query, { isLoading: false });
    } catch (error) {
      console.log("ERROR", error);
      EmitterStatus("ERROR", { logMessage: error });
    } finally {
      setLoadingImport(false);
    }
  };

  const getCountString = (count) => {
    let newCount = count.toString();
    let prefix = 10 - newCount.length;
    for (let i = 0; i < prefix; i++) newCount = "0" + newCount;
    return newCount;
  };

  const PdfDocument = ({
    name = "นาย พนิต จ๋วงพานิช",
    letter_id,
    isFirst = false,
  }) => {
    var now_th = moment.locale("th");
    var today = moment().add(543, "year").format("DD/MM/YYYY");
    var currentYear = moment().add(543, "year").year();
    var rawMonth = moment().format("MM");
    var currentMonth = "มกราคม";
    if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
    if (rawMonth == "03") currentMonth = "มีนาคม";
    if (rawMonth == "04") currentMonth = "เมษายน";
    if (rawMonth == "05") currentMonth = "พฤษภาคม";
    if (rawMonth == "06") currentMonth = "มิถุนายน";
    if (rawMonth == "07") currentMonth = "กรกฎาคม";
    if (rawMonth == "08") currentMonth = "สิงหาคม";
    if (rawMonth == "09") currentMonth = "กันยายน";
    if (rawMonth == "10") currentMonth = "ตุลาคม";
    if (rawMonth == "11") currentMonth = "พฤศจิกายน";
    if (rawMonth == "12") currentMonth = "ธันวาคม";

    var previousYear = Number(currentYear) - 1;
    var header = "หนังสือแจ้งรายปีฉบับที่";
    if (isFirst) {
      header = "หนังสือแจ้งครั้งแรกฉบับที่";
    }
    return (
      <Document>
        {selectedRows.map((row, index) => (
          <Page size="A4" style={styles.page}>
            <Text style={styles.header}>
              หนังสือแจ้งให้ลูกค้าทราบเกี่ยวกับการส่งข้อมูลให้แก่บริษัทข้อมูลเครดิต
              ({header}{" "}
              {(new Date().getFullYear() + 543).toString() +
                "/" +
                getCountString(+letter_id + index + 1)}
              )
            </Text>
            <View style={styles.betweenLine}></View>
            <View style={styles.betweenLine}></View>
            <Text style={styles.date}>วันที่ {today}</Text>
            <View style={styles.betweenLine}></View>
            <Text>เรียน คุณ {row.original.fullname}</Text>
            <View style={styles.newLine}></View>
            <Text style={styles.marginLeft}>
              ตามพระราชบัญญัติการประกอบธุรกิจขอมูลเครดิต พ.ศ. 2545
              และที่แก้ไขเพิ่มเติม และประกาศคณะกรรมการ
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              คุ้มครองข้อมูลเครดิต กำหนดไว้{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
              มีหน้าที่ต้องส่งข้อมูลเครดิตของท่านให้แก่ บริษัท
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              ข้อมูลเครดิตแห่งชาติ จำกัด ที่{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
              เป็นสมาชิกอยู่ และแจ้งให้ท่านทราบเกี่ยวกับข้อมูล
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              เครดิตที่ส่งไป ดังกล่าว ดังนั้น
              เพื่อดำเนินการให้เป็นไปตามบทบัญญัติของพระราชบัญญัติ
              ตลอดจนประกาศคณะ{" "}
            </Text>
            <View style={styles.betweenLine}></View>
            {!isFirst && (
              <View>
                <Text>
                  กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
                  <Text style={styles.bold}>
                    บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                  จึงขอแจ้งให้ท่านทราบว่า ในรอบปี ({currentYear}/
                </Text>
                <View style={styles.betweenLine}></View>
                <Text>
                  {previousYear}) ที่ผ่านมา ได้ส่ง ข้อมูลเครดิตของท่าน ให้แก่
                  บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด แล้วโดยข้อมูลเครดิตที่{" "}
                </Text>
                <View style={styles.betweenLine}></View>
                <Text>
                  <Text style={styles.bold}>
                    บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                  ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้{" "}
                </Text>
              </View>
            )}
            {isFirst && (
              <View>
                <Text>
                  กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
                  <Text style={styles.bold}>
                    บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                  จึงขอแจ้งให้ท่านทราบว่า ใน{" "}
                  <Text style={styles.bold}>เดือน {currentMonth}</Text>
                </Text>
                <View style={styles.betweenLine}></View>
                <Text>
                  <Text style={styles.bold}>
                    ปี {currentYear} บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
                  </Text>{" "}
                  ได้ส่งข้อมูลเครดิตของท่าน ณ{" "}
                  <Text style={styles.bold}>
                    เดือน {currentMonth} ปี {currentYear}
                  </Text>{" "}
                  ให้แก่ บริษัท
                </Text>
                <View style={styles.betweenLine}></View>
                <Text>
                  ข้อมูลเครดิตแห่งชาติ จำกัด แล้ว โดยข้อมูลเครดิตที่{" "}
                  <Text style={styles.bold}>
                    บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
                  </Text>
                  {isFirst ? " ส่งไปดังกล่าว มีรายละเอียด" : ""}
                </Text>
                <View style={styles.betweenLine}></View>
                <Text> ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้ </Text>
              </View>
            )}

            <View style={styles.betweenLine}></View>
            <View style={styles.betweenLine}></View>
            <View style={styles.betweenLine}></View>
            <View style={styles.betweenLine}></View>
            <View style={styles.betweenLine}></View>
            <Text style={styles.marginLeft}>
              {" "}
              ทั้งนี้ ข้อมูลเครดิตที่{" "}
              <Text style={styles.bold}>
                บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
              </Text>{" "}
              นำส่งให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              ดังกล่าว{" "}
              <Text style={styles.red}>
                {isFirst
                  ? "แสดงรายละเอียดการชำระสินเชื่อ"
                  : "ประวัติการชำระสินเชื่อ"}
              </Text>{" "}
              ที่ท่านมีกับ{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
              เพียงสถานะล่าสุดในขณะที่{" "}
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
              จัดทำข้อมูลเพื่อนำส่งข้อมูลเครดิตให้แก่ บริษัท
              ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              ดังกล่าวเท่านั้น ซึ่งข้อมูลเครดิตดังกล่าวอาจแตกต่างจากข้อมูลที่{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
              มีอยู่ในขณะนี้
            </Text>
            <View style={styles.newLine}></View>

            <Text style={styles.marginLeft}>
              จึงเรียนมาเพื่อโปรดทราบ หากท่านมีข้อสงสัย หรือข้อสอบถาม โปรด
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              ติดต่อ{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
              โทรศัพท์ 02-791-1300
            </Text>
            <View style={styles.newLine}></View>
            <Text style={styles.end}>ขอแสดงความนับถือ</Text>
            <View style={styles.betweenLine}></View>
            <View style={styles.betweenLine}></View>
            <Text style={styles.signature}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
            </Text>
          </Page>
        ))}
      </Document>
    );
  };

  const styles = StyleSheet.create({
    page: {
      fontFamily: "Sarabun",
      padding: 26,
      fontSize: 12,
      backgroundColor: "#fff",
    },
    bold: {
      fontFamily: "Sarabun",
      fontWeight: "bold",
    },
    date: {
      textAlign: "right",
    },
    newLine: {
      marginTop: 32,
    },
    marginLeft: {
      marginLeft: 20,
    },
    betweenLine: {
      marginTop: 4,
    },
    header: {
      fontSize: 11,
      textAlign: "center",
    },
    red: {
      color: "red",
    },
    end: {
      textAlign: "right",
      marginRight: 32,
    },
    signature: {
      textAlign: "right",
      marginRight: 16,
      fontWeight: "bold",
    },
  });

  var isProcessing = false;

  const generatePdfDocument = async (isFirst = false) => {
    if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
    else isProcessing = true;
    /// Cal increment Lamba to get Count here
    try {
      const count = await API.put("MoneyHubAdmin", `/letterCount`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
        body: {
          addCount: selectedRows.length,
        },
      });

      const countLatest = Number(count) - selectedRows.length;

      let filename = `CreditBuro_${isFirst ? "first" : "year"}.pdf`;

      const blob = await pdf(
        <PdfDocument
          title={filename}
          letter_id={countLatest}
          isFirst={isFirst}
        />
      ).toBlob();
      saveAs(blob, filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
  };

  const onClickExportExcelBuro = async () => {
    const csvLink = document.getElementById("csv-link");
    setLoadingExport(true);
    const data = await API.get("MoneyHubAdmin", "/creditBuro", {
      queryStringParameters: {
        currentDate,
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });
    setDataExport(
      data.filter((loan) => {
        const diffDefaultDate = differenceInDays(
          new Date(currentDate),
          new Date(loan.overdue_date)
        );
        return diffDefaultDate <= 1915; //มากกว่า 5ปี 90วัน
      })
      // data.filter((el) => el.name === "รัตนาพร")
    );
    setLoadingExport(false);
    csvLink.click();
  };
  function leapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
  }

  const getHeaderTUDF = ({ env = "test" }) => {
    const headerTUDF = {
      headerSegment: {
        position: 1,
        fixedLength: 4,
        value: "TUDF",
        defaultValue: " ",
        isPrefix: true,
      },
      version: {
        position: 5,
        fixedLength: 2,
        value: "13",
        defaultValue: " ",
        isPrefix: true,
      },
      memberCode: {
        position: 7,
        fixedLength: 10,
        value: "CC21070000",
        defaultValue: " ",
        isPrefix: true,
      },
      memberName: {
        position: 17,
        fixedLength: 16,
        value: "MHS",
        defaultValue: " ",
        isPrefix: true,
      },
      cycleIdentification: {
        position: 33,
        fixedLength: 2,
        value: "",
        defaultValue: " ",
        isPrefix: true,
      },
      asOfDate: {
        position: 35,
        fixedLength: 8,
        value: `${format(new Date(currentDate), "yyyyMMdd")}`,
        defaultValue: " ",
        isPrefix: true,
      },
      password: {
        position: 43,
        fixedLength: 8,
        value: env === "test" ? "2A68Q883" : "5FB44922", //5FB44922 production  //2A68Q883 test
        defaultValue: " ",
        isPrefix: true,
      },
      futureUse: {
        position: 51,
        fixedLength: 2,
        value: "00",
        defaultValue: " ",
        isPrefix: true,
      },
      memberData: {
        position: 53,
        fixedLength: 40,
        value: "",
        defaultValue: " ",
        isPrefix: true,
      },
      tracingNumber: {
        position: 93,
        fixedLength: 8,
        value: `${dataExport.length}`,
        defaultValue: "0",
        isPrefix: false,
      },
    };

    let headerStr = "";
    Object.keys(headerTUDF).map((key) => {
      if (headerTUDF[key]) {
        const item = headerTUDF[key];
        var keepStr = "";
        if (!item.value || item.value.length !== item.fixedLength) {
          const fixedLength = item.fixedLength - item.value.length;
          for (let i = 0; i < fixedLength; i++) {
            keepStr += item.defaultValue;
          }
        } else if (item.value.length > item.fixedLength) {
          keepStr += item.value.slice(0, item.fixedLength);
        }
        if (item.isPrefix) {
          headerStr += item.value + keepStr;
        } else {
          headerStr += keepStr + item.value;
        }
      }
    });
    return headerStr;
  };

  const getNamePnSegment = () => {
    let keep = [];
    let namePn = "";
    dataExport.forEach((data) => {
      const splitDate = data?.birthdateTh
        ? data.birthdateTh.split("/")
        : "01/01/1990".split("/");
      const year = +splitDate[2] - 543;
      const month = splitDate[1];
      const day = splitDate[0];
      const dateOfBirth = `${year}${month}${day}`;

      const namePnSegment = {
        pnSegmentTag: { fixedLength: 3, value: "N01", tag: "PN" },
        familyName: { fixedLength: 50, value: data.lastname, tag: "01" },
        firstName: { fixedLength: 30, value: data.name, tag: "04" },
        dateOfBirth: {
          fixedLength: 8,
          value: dateOfBirth,
          tag: "07",
        },
        customerType: {
          fixedLength: 1,
          value: "1",
          tag: "15",
        },
      };

      const idSegment = {
        idSegmentTag: { fixedLength: 3, value: "ID1", tag: "ID" },
        idType: { fixedLength: 2, value: "01", tag: "01" },
        idNumber: { fixedLength: 20, value: data?.citizenid || "", tag: "02" },
      };

      const addressSegment = {
        paSegmentTag: { fixedLength: 3, value: "A01", tag: "PA" },
        address_1: {
          fixedLength: 45,
          value:
            data.currentAddress?.length > 45
              ? data?.currentAddress?.slice(0, 45)
              : data.currentAddress,
          tag: "01",
        },
        address_2: {
          fixedLength: 45,
          value:
            data.currentAddress?.length > 45
              ? data?.currentAddress?.slice(45, data?.currentAddress?.length)
              : null,
          tag: "02",
        },
        country: { fixedLength: 4, value: "TH", tag: "07" },
      };

      const futureInstallments = data.installments.filter(
        (installment) =>
          installment.date > format(new Date(currentDate), "yyyy-MM-dd")
      );

      const futureInstallment = futureInstallments.length
        ? futureInstallments[0]
        : data.installments[data.installments.length - 1];

      let diffPastFuture =
        futureInstallment.actualPrinciple - futureInstallment.planPrinciple;

      let amountPastDue = diffPastFuture <= 0 ? 0 : diffPastFuture;

      let checkDebt =
        data.overdue_date <= format(new Date(currentDate), "yyyy-MM-dd");

      let defaultDate = new Date(data.overdue_date);
      defaultDate.setDate(defaultDate.getDate() + 1);

      const diffOverDueDays = differenceInDays(
        new Date(currentDate),
        data.overdue_date ? new Date(data.overdue_date) : new Date()
      );
      let numberOfDate = "000"; //30
      if (diffOverDueDays >= 31 && diffOverDueDays <= 60) {
        numberOfDate = "001";
      } else if (diffOverDueDays >= 61 && diffOverDueDays <= 90) {
        numberOfDate = "002";
      } else if (diffOverDueDays >= 91 && diffOverDueDays <= 120) {
        numberOfDate = "003";
      } else if (diffOverDueDays >= 121 && diffOverDueDays <= 150) {
        numberOfDate = "004";
      } else if (diffOverDueDays >= 151 && diffOverDueDays <= 180) {
        numberOfDate = "005";
      } else if (diffOverDueDays >= 181 && diffOverDueDays <= 210) {
        numberOfDate = "006";
      } else if (diffOverDueDays >= 211 && diffOverDueDays <= 240) {
        numberOfDate = "007";
      } else if (diffOverDueDays >= 241 && diffOverDueDays <= 270) {
        numberOfDate = "008";
      } else if (diffOverDueDays >= 271 && diffOverDueDays <= 300) {
        numberOfDate = "009";
      } else if (diffOverDueDays > 300) {
        numberOfDate = "  F";
      }

      let accountStatus = 10;
      if (data.loan_status === "DONE") {
        accountStatus = 11;
      }
      if (diffOverDueDays > 90) {
        accountStatus = 20;
      }

      const currentInstallments = data.installments.filter((installment) => {
        // const today = new Date(currentDate);
        // const splitDate = installment?.date?.split("-");
        // const month = splitDate[1];
        // return month === `${pad(today.getMonth() + 1)}`;
        return installment.date <= currentDate;
      });

      const accountSegment = {
        tlSegmentTag: { fixedLength: 4, value: "T001", tag: "TL" },
        memberCode: { fixedLength: 10, value: "CC21070000", tag: "01" },
        memberName: { fixedLength: 16, value: "MHS", tag: "02" },
        accountNumber: {
          fixedLength: 25,
          value: data?.loan_id || "",
          tag: "03",
        },
        accountType: { fixedLength: 2, value: "05", tag: "04" },
        ownershipIndicator: { fixedLength: 1, value: "1", tag: "05" },
        currencyCode: { fixedLength: 3, value: "THB", tag: "06" },
        dateAccountOpened: {
          fixedLength: 8,
          value: format(new Date(data.requestTime), "yyyyMMdd"),
          tag: "08",
        },
        dateOfLastPayment: {
          fixedLength: 8,
          value: data?.paid_date_latest
            ? format(new Date(data.paid_date_latest), "yyyyMMdd")
            : "19000101",
          tag: "09",
        },
        dateAccountClosed: {
          fixedLength: 8,
          // value: "19000101",
          // value: !currentInstallments?.length
          //   ? format(
          //       new Date(data.installments[data.installments.length - 1].date),
          //       "yyyyMMdd"
          //     )
          //   : `${format(
          //       new Date(
          //         currentInstallments[currentInstallments.length - 1].date
          //       ),
          //       "yyyyMMdd"
          //     )}`,
          value:
            data.loan_status === "ACTIVE"
              ? "19000101"
              : format(new Date(data.endDate), "yyyyMMdd"),
          tag: "10",
        },
        // asOfDate: {
        //   fixedLength: 8,
        //   value: data.paid_date_latest
        //     ? format(new Date(data.paid_date_latest), "yyyyMMdd")
        //     : "19000101",
        //   tag: "11",
        // },
        loanAmount: {
          fixedLength: 9,
          value: `${Number(data.requestamount)}`,
          tag: "12",
        },
        amountOwed: {
          fixedLength: 9,
          value:
            // `${Number(data.capitalRemain) + Number(data.interestMore)}`,
            data.loan_status === "DONE" ? "0" : `${Number(data.capitalRemain)}`,
          tag: "13",
        },
        amountPastDue: {
          fixedLength: 9,
          value: `${Number(amountPastDue)}`,
          tag: "14",
        },
        numberOfDate: {
          fixedLength: 3,
          value: `${numberOfDate}`,
          tag: "15",
        },
        defaultDate: {
          fixedLength: 8,
          value: "19000101",
          value:
            data.loan_status === "ACTIVE" && checkDebt
              ? format(defaultDate, "yyyyMMdd")
              : "19000101",
          tag: "19",
        },
        installmentFrequency: {
          fixedLength: 1,
          value: "3",
          tag: "20",
        },
        installmentAmount: {
          fixedLength: 9,
          value: !currentInstallments?.length
            ? data.installments[data.installments.length - 1].planPrinciple
            : `${currentInstallments[0].planPrinciple}`,
          // value: `${Math.ceil(Number(data.requestamount / data.period))}`,
          tag: "21",
        },
        installmentNumberOfPayment: {
          fixedLength: 4,
          value: data.period > 10 ? `00${data.period}` : `000${data.period}`,
          tag: "22",
        },
        accountStatus: {
          fixedLength: 2,
          value: `${accountStatus}`,
          tag: "23",
        },
        loanObjective: {
          fixedLength: 5,
          value: "55555",
          tag: "32",
        },
        dateOfLastDebt: {
          fixedLength: 8,
          value: "19000001",
          tag: "36",
        },
        numberOfCoBorrower: {
          fixedLength: 2,
          value: "00",
          tag: "39",
        },
      };

      const includeSegment = {
        ...namePnSegment,
        ...idSegment,
        ...addressSegment,
        ...accountSegment,
      };

      const keepSegment = {
        ...includeSegment,
        // namePnSegment,
        // idSegment,
        // addressSegment,
        // accountSegment,
      };

      keep.push(keepSegment);
      // console.log("includeSegment", includeSegment);

      Object.keys(includeSegment).map((key) => {
        if (includeSegment[key]) {
          const item = includeSegment[key];
          if (item.value !== null) {
            var keepStr = "";
            if (item.value?.length > item?.fixedLength) {
              keepStr += item.value.slice(0, item.fixedLength);
            }
            namePn +=
              keepStr + `${item.tag}${pad(item.value.length)}${item.value}`;
          }
        }
      });
      namePn += `ES02**\n`;
    });
    return namePn;
  };

  const dataCsv = `${getHeaderTUDF({
    env: "test",
  })}\n${getNamePnSegment()}TRLR`;

  const headers = [
    { label: "Job No", key: "job_no" },
    { label: "EMS Year", key: "ems_year" },
    { label: "EMS Initial", key: "ems_initial" },
    { label: "ชื่อ", key: "fullname" },
    { label: "จำนวนงวด", key: "period" },
    { label: "ประเภทสินเชื่อ", key: "type" },
    { label: "เงินทุน", key: "initCapital" },
    { label: "เบอร์โทร", key: "phone_number" },
  ];

  const dataCsvExport = selectedRows?.map((row) => {
    const { original } = row;
    return {
      job_no: original.loan_id,
      ems_year: original.ems_year,
      ems_initial: original.ems_initial,
      fullname: original.fullname,
      period: original.period,
      type: original.type,
      initCapital: original.initCapital,
      phone_number: original.phone_number,
    };
  });

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i].original.loan_kbank_id,
          style,
        },
        {
          value: data[i].original.ems_year || "-",
          style,
        },
        {
          value: data[i].original.ems_initial || "-",
          style,
        },
        {
          value: data[i].original.name + " " + data[i].original.lastname,
          style,
        },
        {
          value: data[i].original.period,
          style,
        },
        {
          value: data[i].original.type,
          style,
        },
        {
          value: data[i].original.requestamount,
          style,
        },
        {
          value: data[i].original.phone_number,
          style,
        },
        {
          value: format(new Date(data[i].original.requestTime), "dd-MM-yyyy"),
          style,
        },
        {
          value: data[i].original.adminName || "-",
          style,
        },
        {
          value: data[i].original.buroDate
            ? format(new Date(data[i].original.buroDate), "dd-MM-yyyy")
            : "-",
          style,
        },
      ]);
    }
    return result;
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // borders: {
    //   top: { style: "thin" },
    //   bottom: { style: "thin" },
    //   left: { style: "thin" },
    //   right: { style: "thin" },
    // },
  };

  const onClickExport = () => {
    const exportClick = document.getElementById("buro");
    exportClick.click();
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "Job no",
          width: { wch: 28 },
          style,
        }, //pixels width
        {
          title: "EMS Year",
          width: { wch: 38 },
          style,
        }, //pixels width
        {
          title: "EMS Initial",
          width: { wch: 24 },
          style,
        }, //char width
        {
          title: "ชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 24 },
          style,
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "เงินทุน",
          width: { wch: 24 },
          style,
        },
        {
          title: "เบอร์โทร",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 36 },
          style,
        },
        {
          title: "แก้ไขโดย",
          width: { wch: 24 },
          style,
        },
        {
          title: "BuroDate",
          width: { wch: 24 },
          style,
        },
      ],
      data: createDataWithStyle(selectedRows),
    },
  ];

  return (
    <ContainerContent>
      <div className="mx-4 w-full mb-2 lg:flex items-center">
        {/* <div className=" flex items-center justify-center">
          วันที่ปัจจุบัน Test Buro
          <input
            value={currentDate}
            onChange={(e) => setCurrentDate(e.target.value)}
            type="date"
            className="p-2 py-1 border rounded shadow-sm"
          />
        </div> */}
        {loadingImport && (
          <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
            <div className="w-2/5 h-auto mx-auto  ">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Loading,
                  isStopped: false,
                  isPaused: false,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
              />
              <div className="text-center text-white text-xl">
                กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
              </div>
            </div>
          </div>
        )}
        {/* <div className="flex items-center my-1 lg:my-0 lg:ml-2">
          <div className="lg:mx-2 ">วันที่ปัจจุบัน</div>
          <input
            value={query.overDueDate}
            onChange={onField}
            name="overDueDate"
            type="date"
            className="p-2 py-1 border rounded shadow-sm mr-2"
          />
        </div> */}
        <div className="">
          ค้นหาโดยใช้&nbsp;
          <label class="inline-flex items-center lg:ml-2">
            <input
              onChange={(e) => setSearchBy("loan_id")}
              type="radio"
              class="form-radio"
              name="search"
              defaultChecked={true}
              checked={searchBy === "loan_id"}
            />
            <span class="ml-2">Job. No.</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("name")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "name"}
            />
            <span class="ml-2">ชื่อ</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("requestamount")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "requestamount"}
            />
            <span class="ml-2">วงเงินที่ได้</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("adminName")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "adminName"}
            />
            <span class="ml-2">ชื่อแอดมิน</span>
          </label>
        </div>
      </div>

      <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div className="ml-2">
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onImportExcel}
          />
        </div>{" "}
        <ExcelFile
          filename={`CREDITBURO${format(new Date(), "yyyy-MM-dd")}`}
          element={<button id="buro" hidden></button>}
        >
          <ExcelSheet dataSet={multiDataSet} name="CREDITBURO"></ExcelSheet>
        </ExcelFile>
        <button
          disabled={!selectedRows.length}
          className={classNames(
            "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
            {
              "bg-gray-300  text-white cursor-not-allowed":
                !selectedRows.length,
              "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white cursor-pointer":
                selectedRows.length,
            }
          )}
          onClick={onClickExport}
        >
          Export Excel
        </button>
        <button
          disabled={loadingExport}
          onClick={onClickExportExcelBuro}
          className={classNames(
            "ml-2 border p-1 px-2 rounded  text-white duration-300 ",
            {
              "border-yellow-500 cursor-pointer   hover:bg-yellow-600 bg-yellow-500  hover:text-white":
                !loadingExport,
              "bg-gray-500 cursor-not-allowed": loadingExport,
            }
          )}
        >
          {loadingExport ? "loading..." : "Export Buro"}
        </button>
        <CSVLink
          id="csv-link"
          hidden
          data={dataCsv}
          filename={`TUCRS-MHS-${format(new Date(todayBuro), "yyyy-MM")}.txt`}
        />
        {/* <CSVLink
          disabled={!selectedRows.length}
          headers={headers}
          data={dataCsvExport}
          filename={`CREDIT_BURO_${format(new Date(), "dd-MM-yyyy")}.xls`}
        >
          <button
            disabled={!selectedRows.length}
            className={classNames(
              "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
              {
                "bg-gray-300 cursor-not-allowed text-white":
                  !selectedRows.length,
                "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                  selectedRows.length,
              }
            )}
          >
            Export Excel
          </button>
        </CSVLink> */}
        <button
          disabled={loadingUpdateBuro}
          className={classNames(
            "ml-2 border p-1 px-2 rounded duration-300 text-white",
            {
              "bg-yellow-500": !loadingUpdateBuro,
              "bg-gray-400": loadingUpdateBuro,
            }
          )}
          onClick={onUpdateBuroDate}
        >
          {loadingUpdateBuro && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          วันที่ ส่งเครดิตบูโรล่าสุด 
          {format(new Date(), "dd-MM-yyyy hh:mm")}
        </button>
        <button
          disabled={!selectedRows.length}
          className={classNames(
            "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
            {
              "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
              "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                selectedRows.length,
            }
          )}
          onClick={() => generatePdfDocument(true)}
        >
          ออกจดหมายครั้งแรก
        </button>
        <button
          disabled={!selectedRows.length}
          className={classNames(
            "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
            {
              "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
              "border-pink-500 text-pink-500 hover:bg-pink-600 hover:text-white":
                selectedRows.length,
            }
          )}
          onClick={() => generatePdfDocument()}
        >
          ออกจดหมายรายปี
        </button>
      </div>

      <div className="mx-4 w-full mb-6 lg:flex">
        <React.Fragment>
          <div className="lg:flex items-center ">
            <div className="lg:mr-2">วันที่เริ่มสร้าง</div>
            <input
              name="min_created"
              value={query.min_created}
              onChange={onField}
              type="date"
              className="p-2 py-1 border rounded shadow-sm"
            />
          </div>
          <div className="lg:flex items-center lg:ml-4">
            <div className="lg:mr-2">ถึง</div>
            <input
              name="max_created"
              value={query.max_created}
              onChange={onField}
              type="date"
              className="p-2 py-1 border rounded shadow-sm mr-2"
            />
          </div>
        </React.Fragment>
        <button
          className="ml-2 border border-blue-500 p-1 px-2 rounded text-blue-500 hover:bg-blue-600 duration-300 hover:text-white"
          onClick={onSubmitFilter}
        >
          Submit
        </button>
        <button
          className="ml-2 p-1 px-2 border border-red-500  rounded text-red-500 hover:bg-red-200 duration-300 hover:text-white"
          onClick={onClickResetFilter}
        >
          Clear
        </button>
        <svg
          onClick={() => getData(query)}
          xmlns="http://www.w3.org/2000/svg"
          className="h-9 w-9 rounded border border-gray-500 hover:bg-gray-200 text-gray-700 ml-2 p-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
      {!datas?.length ? (
        <ContainerContent>
          <DataEmpty />
        </ContainerContent>
      ) : (
        <React.Fragment>
          <div className="mx-4">{datas.length} Records</div>
          <BuroTable
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            // overdueDateMax={query.max}
            overDueDate={query.overDueDate}
            data={datas}
            getData={getData}
            query={query}
          />
          <div className=" mx-4 mt-4 flex justify-between ">
            <nav
              className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
              aria-label="Pagination"
            >
              <PrevPage
                canPreviousPage={canPreviousPage}
                onClick={onClickPrevPage}
              />
              {paginationPages.map((_, i) => {
                const number = getNumberPage(i);
                return (
                  <NumberPage
                    number={number}
                    pageIndex={pageIndex}
                    gotoPage={() => onClickNumberPage(number)}
                  />
                );
              })}
              <NextPage onClick={onClickNextPage} canNextPage={canNextPage} />
            </nav>
            <div className="w-24 flex">
              <SelectRows
                pageSize={pageSize}
                onChange={onChangeLimit}
                options={optionsLimit}
              />
            </div>
          </div>
        </React.Fragment>
      )}
    </ContainerContent>
  );
}

export default Buro;
